import NavLink from 'base/components/NavLink/NavLink';

export default NavLink;
